import TextFieldComponent from '@components/inputs/textField/TextField.component';
import ModalComponent from '@components/modal/Modal.component';
import { Colors } from '@constants/colors.constants';
import { Sizes } from '@constants/sizes.constants';
import { Button, Stack, Typography } from '@mui/material';
import { auditsOfferService } from '@store/audits/audit-offer/audit-offer.services';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { finalize, switchMap } from 'rxjs';
import { AuditOfferPriceGroupedActionDto } from '../../../../store/audits/audit-offer/audit-offer.model';

interface GroupedProps {
  price: number;
  marge: number;
}

interface GroupModalProps {
  handleCloseModal: () => void;
  selectedProposalRow : number[];
}

const GroupModal = (props: GroupModalProps) => {
  const { handleCloseModal, selectedProposalRow } = props;
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { auditId } = useParams();

  const [groupedUpdate, setGroupedUpdate] = useState<Partial<GroupedProps>>();

  const updateGroupe = (name: string) => (value: any) => setGroupedUpdate((state) => ({ ...state, [name]: value }));

  const handleValidate = () => {

    const payload: AuditOfferPriceGroupedActionDto = {
      auditOfferIds: selectedProposalRow,
      marginInPercent: Number(groupedUpdate?.marge),
      unitPriceInCents: Number(groupedUpdate?.price) * 100
    };

    auditsOfferService.PatchPriceGroupActions(payload).pipe(
      finalize(() => handleCloseModal()),
      switchMap(() => auditsOfferService.GETAuditOffersByAudit(auditId as string))
    ).subscribe({
      error: (err) => enqueueSnackbar(err.text, err.options),
      next: () => {
        enqueueSnackbar(t('audits.success.offer.price-group-action'), { variant: 'success' });
        handleCloseModal();
      },
    });
  };

  return (
    <ModalComponent
      aria-label="over-drawer"
      title={t('audits.OfferFormalization.groupedModal.title')}
      handleClose={handleCloseModal}
      customColor='#FFFFFF'
      contentHeight='50dvh'
      contentFullWidth
      content={(
        <Stack width="100%" height={'100%'} bgcolor='#F4F6F8' justifyContent='center' alignItems='center' spacing={5}>
          <Stack spacing={3}>
            <TextFieldComponent
              color="secondary"
              labelWidth={Sizes.unitDetailsInputLabelWidth}
              label={t('audits.OfferFormalization.groupedModal.clientPrice')}
              placeholder={t('audits.OfferFormalization.groupedModal.placeholderPrice')}
              pattern={/^\d+$/}
              handleChange={(value) => {
                updateGroupe('marge')('');
                updateGroupe('price')(value);
              }}
              value={groupedUpdate?.price?.toString() || ''}
              endAdornment={<Typography fontSize='14px' color={Colors.lightGrey}>CHF</Typography>}
            />
            <TextFieldComponent
              color="secondary"
              labelWidth={Sizes.unitDetailsInputLabelWidth}
              label={t('audits.OfferFormalization.groupedModal.marge')}
              pattern={/^\d+$/}
              placeholder={t('audits.OfferFormalization.groupedModal.placeholderMarge')}
              handleChange={(value) => {
                updateGroupe('price')('');
                updateGroupe('marge')(value);
              }}
              endAdornment={<Typography fontSize='14px' color={Colors.lightGrey}>%</Typography>}
              value={groupedUpdate?.marge?.toString() || ''}
            />
          </Stack>
          <Button variant='contained' disabled={!groupedUpdate?.marge && !groupedUpdate?.price} onClick={handleValidate}>
            {t('global.validate')}
          </Button>
        </Stack>
      )}
    />
  );
};

export default GroupModal;